var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen" },
    [
      _c("navBar", {
        attrs: {
          title: _vm.isEdit
            ? _vm.$t("address.editAddress")
            : _vm.$t("address.addAddress"),
        },
      }),
      _c(
        "div",
        { staticClass: "bg-white rounded-lg mx-4 mt-3" },
        [
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.name"),
              placeholder: _vm.$t("address.namePlaceholder"),
            },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.phone"),
              placeholder: _vm.$t("address.phonePlaceholder"),
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex-1 flex items-center justify-end" },
                      [
                        _c(
                          "div",
                          [
                            _c("van-field", {
                              staticClass: "p-0",
                              attrs: {
                                placeholder: _vm.$t(
                                  "address.countryCodePlaceholder"
                                ),
                                readonly: "",
                                "is-link": "",
                              },
                              on: {
                                "click-input": function ($event) {
                                  _vm.showCountryCodePopup = true
                                },
                              },
                              model: {
                                value: _vm.form.countryCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "countryCode", $$v)
                                },
                                expression: "form.countryCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("van-field", {
                          staticClass: "p-0 w-40 bg-orange-500",
                          attrs: {
                            placeholder: _vm.$t("address.phonePlaceholder"),
                          },
                          model: {
                            value: _vm.form.mobile,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mobile", $$v)
                            },
                            expression: "form.mobile",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.country"),
              placeholder: _vm.$t("address.countryPlaceholder"),
              readonly: "",
              "is-link": "",
            },
            on: { "click-input": _vm.handleCountry },
            model: {
              value: _vm.form.country,
              callback: function ($$v) {
                _vm.$set(_vm.form, "country", $$v)
              },
              expression: "form.country",
            },
          }),
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.city"),
              placeholder: _vm.$t("address.cityPlaceholder"),
              readonly: "",
              "is-link": "",
            },
            on: {
              "click-input": function ($event) {
                _vm.showCityPopup = true
              },
            },
            model: {
              value: _vm.form.city,
              callback: function ($$v) {
                _vm.$set(_vm.form, "city", $$v)
              },
              expression: "form.city",
            },
          }),
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.zipCode"),
              "label-width": "100px",
              placeholder: _vm.$t("address.zipCodePlaceholder"),
            },
            model: {
              value: _vm.form.zipCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "zipCode", $$v)
              },
              expression: "form.zipCode",
            },
          }),
          _c("van-field", {
            attrs: {
              label: _vm.$t("address.detailAddress"),
              "label-width": "100px",
              placeholder: _vm.$t("address.detailAddressPlaceholder"),
              type: "textarea",
            },
            model: {
              value: _vm.form.detailAddress,
              callback: function ($$v) {
                _vm.$set(_vm.form, "detailAddress", $$v)
              },
              expression: "form.detailAddress",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "bg-white rounded-lg mx-4 mt-2 p-3 flex items-center justify-between",
        },
        [
          _c("span", { staticClass: "text-[#646566] text-sm" }, [
            _vm._v(_vm._s(_vm.$t("address.setAsDefault"))),
          ]),
          _c("van-switch", {
            attrs: { size: "20px", "active-color": "#ff7a00" },
            model: {
              value: _vm.form.defaultStatus,
              callback: function ($$v) {
                _vm.$set(_vm.form, "defaultStatus", $$v)
              },
              expression: "form.defaultStatus",
            },
          }),
        ],
        1
      ),
      _c(
        "van-button",
        {
          staticClass:
            "mx-16 w-[calc(100%-8rem)] mb-4 mt-10 bg-orange-500 border-orange-500",
          attrs: { type: "primary", round: "" },
          on: { click: _vm.handleSave },
        },
        [_vm._v(" " + _vm._s(_vm.$t("address.save")) + " ")]
      ),
      _vm.isEdit
        ? _c(
            "van-button",
            {
              staticClass:
                "mx-16 w-[calc(100%-8rem)] mb-3 text-[#ff7a00] border-orange-500",
              attrs: { plain: "", round: "", type: "danger" },
              on: { click: _vm.handleDelete },
            },
            [_vm._v(" " + _vm._s(_vm.$t("address.delete")) + " ")]
          )
        : _vm._e(),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryPopup,
            callback: function ($$v) {
              _vm.showCountryPopup = $$v
            },
            expression: "showCountryPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryList },
            on: {
              confirm: _vm.onCountryConfirm,
              cancel: function ($event) {
                _vm.showCountryPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCityPopup,
            callback: function ($$v) {
              _vm.showCityPopup = $$v
            },
            expression: "showCityPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.cityList },
            on: {
              confirm: _vm.onCityConfirm,
              cancel: function ($event) {
                _vm.showCityPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryCodePopup,
            callback: function ($$v) {
              _vm.showCountryCodePopup = $$v
            },
            expression: "showCountryCodePopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryCodeList },
            on: {
              confirm: _vm.onCountryCodeConfirm,
              cancel: function ($event) {
                _vm.showCountryCodePopup = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function (slotProps) {
                  return [
                    _c("div", { staticClass: "flex items-center text-sm" }, [
                      _c("img", {
                        staticClass: "w-5 h-auto",
                        attrs: { src: slotProps.icon, alt: "" },
                      }),
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(_vm._s(slotProps.text)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }